import * as React from 'react';
import {
    OutlinedInput,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    Checkbox,
    ListSubheader,
    TextField,
    Box,
    Typography,
    Tooltip,
    Avatar,
} from '@mui/material';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 300,
        },
    },
    disableAutoFocusItem: true,
};

const getInitials = (fullName) => {
    const parts = fullName.trim().split(' ');
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

function TruncatedTooltip({ children }) {
    const textRef = React.useRef(null);
    const [isTruncated, setIsTruncated] = React.useState(false);

    React.useEffect(() => {
        const el = textRef.current;
        if (el) {
            setIsTruncated(el.scrollWidth > el.clientWidth);
        }
    }, [children]);

    return isTruncated ? (
        <Tooltip title={children}>
            <Typography
                ref={textRef}
                noWrap
                sx={{
                    maxWidth: '160px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: '14px',
                    color: '#111',
                    cursor: 'default',
                }}
            >
                {children}
            </Typography>
        </Tooltip>
    ) : (
        <Typography
            ref={textRef}
            noWrap
            sx={{
                maxWidth: '160px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: '14px',
                color: '#111',
            }}
        >
            {children}
        </Typography>
    );
}
export default function ActivityLevel({
    label = 'Select User',
    options = [],
    selectedValue = '',
    onChange = () => { },
}) {
    const [searchTerm, setSearchTerm] = React.useState('');

    const handleChange = (event) => {
        onChange(event.target.value);
    };

    const filteredOptions = options.filter((opt) =>
        opt.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const selectedOption = options.find((opt) => opt.name === selectedValue);

    return (
        <FormControl sx={{ m: 0, width: '100%' }}>
            <Select
                id={`${label}-select`}
                value={selectedValue}
                onChange={handleChange}
                displayEmpty
                input={
                    <OutlinedInput
                        sx={{
                            height: 38,
                            borderRadius: '50px',
                            paddingRight: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            fontFamily: 'Manrope'
                        }}
                    />
                }
                renderValue={() =>
                    selectedOption ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontFamily: 'Manrope' }}>
                            <Typography sx={{ fontFamily: 'Manrope', fontSize: '14px' }}>{selectedOption.name}</Typography>
                        </Box>
                    ) : (
                        <Typography sx={{ color: '#A0AEC0', fontFamily: 'Manrope', fontSize: '14px' }}>{label}</Typography>
                    )
                }
                MenuProps={MenuProps}
                sx={{
                    background: '#fff',
                    borderRadius: '6px',
                    '& .MuiSelect-select': {
                        paddingTop: '8px',
                        paddingBottom: '7px',
                        height: 23,
                        fontSize: '12px',
                        color: '#64748B',
                        fontFamily: 'Manrope'
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderRadius: '6px',
                        fontFamily: 'Manrope'
                    },
                }}
            >
                <ListSubheader>
                    <Box
                        disableRipple
                        disableTouchRipple
                        sx={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 999,
                            background: '#fff !important',
                            borderRadius: '100px',
                            fontFamily: 'Manrope',
                            fontSize: '14px',
                            '& .MuiInputBase-root': {
                                borderRadius: '100px',
                                height: '38px',
                                fontFamily: 'Manrope',
                                fontSize: '14px'

                            }
                        }}
                    >
                        <TextField
                            sx={{ background: '#fff', borderRadius: '100px', fontFamily: 'Manrope', fontSize: '14px' }}
                            fullWidth
                            size="small"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyDown={(e) => {
                                e.stopPropagation();

                            }}
                            onMouseDown={(e) => {
                                e.stopPropagation();

                            }}
                        />
                    </Box>
                </ListSubheader>


                {filteredOptions.map((opt) => (
                    <MenuItem key={opt.name} value={opt.name}>
                        <KeyboardArrowRightIcon sx={{ fontSize: '14px', fontFamily: 'Manrope' }} />
                        <TruncatedTooltip sx={{ fontFamily: 'Manrope', fontSize: '14px' }}>{opt.name}</TruncatedTooltip>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>

    );
}
